module.exports = __webpack_public_path__ + "static/media/sim-card-replacement.9cdc0802.svg";